/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Outlook_Mail_Recipients_MoreInputs */



/**
* | output |
* | --- |
* | "+{count} more" |
*
* @param {Chat_Outlook_Mail_Recipients_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_mail_recipients_more = /** @type {((inputs: Chat_Outlook_Mail_Recipients_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Mail_Recipients_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`+${i?.count} weitere`)
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
});